import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { CgLogOut } from "react-icons/cg";
import { Button } from "react-bootstrap";



const LogoutButton = () => {
  const { logout } = useAuth0();

  return (

    <Button className="logout-btn" onClick={() => logout({ returnTo: window.location.origin })}>
      Log Out <CgLogOut/>
    </Button>


  );
};

export default LogoutButton;